/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ currency: NonNullable<unknown> }} Salary_Ranges_TitleInputs */

const en_salary_ranges_title = /** @type {(inputs: Salary_Ranges_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Salary Ranges (${i?.currency})`)
};

const de_salary_ranges_title = /** @type {(inputs: Salary_Ranges_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gehaltsspannen (${i?.currency})`)
};

const fr_salary_ranges_title = /** @type {(inputs: Salary_Ranges_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fourchettes salariales (${i?.currency})`)
};

const es_salary_ranges_title = /** @type {(inputs: Salary_Ranges_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rangos salariales (${i?.currency})`)
};

const it_salary_ranges_title = /** @type {(inputs: Salary_Ranges_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fasce salariali (${i?.currency})`)
};

const nl_salary_ranges_title = /** @type {(inputs: Salary_Ranges_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Salarisbereiken (${i?.currency})`)
};

const pl_salary_ranges_title = /** @type {(inputs: Salary_Ranges_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zakresy wynagrodzeń (${i?.currency})`)
};

const fi_salary_ranges_title = /** @type {(inputs: Salary_Ranges_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Palkkahaarukat (${i?.currency})`)
};

const da_salary_ranges_title = /** @type {(inputs: Salary_Ranges_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lønspænd (${i?.currency})`)
};

const sv_salary_ranges_title = /** @type {(inputs: Salary_Ranges_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lönespann (${i?.currency})`)
};

/**
* | output |
* | --- |
* | "Salary Ranges ({currency})" |
*
* @param {Salary_Ranges_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_ranges_title = /** @type {((inputs: Salary_Ranges_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Ranges_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_ranges_title(inputs)
	if (locale === "fr") return fr_salary_ranges_title(inputs)
	if (locale === "es") return es_salary_ranges_title(inputs)
	if (locale === "it") return it_salary_ranges_title(inputs)
	if (locale === "nl") return nl_salary_ranges_title(inputs)
	if (locale === "pl") return pl_salary_ranges_title(inputs)
	if (locale === "fi") return fi_salary_ranges_title(inputs)
	if (locale === "da") return da_salary_ranges_title(inputs)
	if (locale === "sv") return sv_salary_ranges_title(inputs)
	return en_salary_ranges_title(inputs)
});